module.exports = __webpack_public_path__ + "img/epr_medium.8b1b742b.webp";